// Styles for Footer go here.
import styled from 'styled-components';
import { theme } from '../../../styles';
import { colors } from '../../../styles/colors';

export const StyledFooter = styled.div`
  .lt-footer {
    padding: 55px 0 0;
    background-color: ${colors.coral};
  }
  .lt-footer-inner {
    padding: 15px 35px;
  }
  .lt-footer .logo {
    width: 215px;
    height: auto;
  }
  .lt-footer nav {
    display: flex;
    gap: 30px;
  }
  .lt-footer nav a {
    font-size: 16px;
    line-height: 14px;
    text-transform: uppercase;
    letter-spacing: 1.7px;
  }
  .lt-footer .lt-social {
    display: flex;
    gap: 20px;
    margin-top: 30px;
  }
  @media ${theme.ltMediaQuery.tablet} {
    .lt-footer .lt-social {
      margin-top: 0;
    }
  }
  .lt-footer .lt-legal {
    background-color: ${colors.black};
    color: ${colors.white};
    margin-top: 55px;
    padding: 15px 35px;
    font-size: 16px;
    line-height: 24px;
  }
  .lt-footer .lt-legal-inner {
    display: flex;
    flex-direction: column;
  }
  @media ${theme.ltMediaQuery.largeDesktop} {
    .lt-footer .lt-legal-inner {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }
  .lt-footer .lt-legal .lt-legal-links {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0 15px;
  }
  @media ${theme.ltMediaQuery.largeDesktop} {
    .lt-footer .lt-legal .lt-legal-links {
      justify-content: flex-end;
    }
  }
  .lt-footer .lt-legal .lt-legal-links a {
    color: ${colors.white};
  }
  @media ${theme.ltMediaQuery.desktop} {
    .lt-footer .lt-legal .lt-legal-links a {
      font-size: 14px;
    }
  }
  .lt-copyright p {
    margin-bottom: 0;
  }
  .lt-footer .lt-legal .lt-legal-links #teconsent,
  .lt-footer .lt-legal .lt-legal-links #ccpacontainer {
    display: inline-flex;
    align-items: center;
    @media ${theme.ltMediaQuery.desktop} {
      a {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
`;
